

export class TimeUtils
{
    public static SecondsToHHMMSS(sekundy: number): string
    {
        let h = Math.floor(sekundy / 3600);
        let m = Math.floor((sekundy % 3600) / 60);
        let s = sekundy % 60;

        const hh = (h < 10) ? "0" + h : h;
        const mm = (m < 10) ? "0" + m : m;
        const ss = (s < 10) ? "0" + s : s;

        return hh + ":" + mm + ":" + ss;
    }
}
